import { LocalStorage } from '@/common/js/LocalStorage.js'

const ls = new LocalStorage()
const user = ls.getUser()
const isLogin = user ? user.isLogin : false

export default {
  count: 0,
  isLoading: false, // 请求是否正在加载，true -> 加载中，false -> 为加载或已加载完成
  isLogin, // 用户是否登录, true -> 登录，false -> 未登录
  showLogin: false, // 是否显示登录 modal, true -> 显示，false -> 不显示
  message: { // 用户操作 message
    msg: '', // 具体文言
    type: '', // 操作类型 'info', 'success', 'warning', 'error'
    cb: null, // message 显示完成回调
    timestamp: null // 生成 message 时间戳
  },
  mapAddress: {
    addressData: {}, // 省、市、区、详细地址 {province, city, district, address, fullAddress}
    sysAreaId: '', // 地区ID
    point: {}, // {lng, lat}
    info: [] // 关键字检索推荐信息
  },
  pageHasPosition: true,
  // 国际区号
  mobileCode: [
    {code: 86, name: '中国大陆'},
    {code: 852, name: '中国香港'},
    {code: 853, name: '中国澳门'},
    {code: 886, name: '中国台湾'},
    {code: 81, name: '日本'},
    {code: 82, name: '韩国'},
    {code: 1, name: '美国/加拿大'},
    {code: 7, name: '俄罗斯'},
    {code: 49, name: '德国'},
    {code: 33, name: '法国'},
    {code: 44, name: '英国'},
    {code: 61, name: '澳大利亚'},
    {code: 91, name: '印度'},
    {code: 39, name: '意大利'},
    {code: 66, name: '泰国'},
    {code: 62, name: '印度尼西亚'},
    {code: 60, name: '马来西亚'},
    {code: 63, name: '菲律宾'},
    {code: 65, name: '新加坡'}
  ]
}



// WEBPACK FOOTER //
// ./src/store/state.js